module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_f_albino.ae12149d.png";